import { usePixelLoader } from '~/hooks/usePixelLoader';

interface PixelProps {
  pixelId: string;
  marketingCookies: boolean;
}

const GA4Pixel = ({ pixelId, marketingCookies }: PixelProps) => {
  usePixelLoader(() => {
    // match valid pixel id: G- followed by 8+ alphanumeric chars
    if (pixelId?.match(/^G-[A-Z0-9]{8,}$/) && marketingCookies) {
      const script1 = document.createElement('script');
      script1.async = true;
      script1.src = `https://www.googletagmanager.com/gtag/js?id=${pixelId}`;
      document.head.appendChild(script1);

      const script2 = document.createElement('script');
      script2.async = true;
      script2.id = 'ga-pixel';
      script2.innerHTML = `
        (function(){try{
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${pixelId}', {
          page_path: window.location.pathname,
        });
        }catch{/*swallow exception*/}})();
      `;
      document.head.appendChild(script2);
    }
  }, [pixelId, marketingCookies]);

  return null;
};

export default GA4Pixel;
